// import * as FindaStoreActionTypes from '../actionTypes/FindaStoreActionTypes';
import * as HomePageActionTypes from '../actionTypes/HomePageActionTypes';

export const onPageReady = () => ({ // eslint-disable-line
    type: HomePageActionTypes.FINDASTORE_PAGE_LOAD_READY,
    payload: { pageName: 'find a store' },
});
